import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from './core/services/authentication.service';
import { SessionStateService } from './core/services/session-state.service';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Observable } from 'rxjs';
declare var ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'app';
  constructor(public router: Router,
              private sessionStateService: SessionStateService,
              private authenticationService: AuthenticationService) {    
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     ga('set', 'page', event.urlAfterRedirects);
    //     ga('send', 'pageview');
    //   }
    // });
  }

  ngOnInit(): void {
    const cognitoUser: any = this.authenticationService.getAuthenticatedUser();
    if (cognitoUser) {
      if (cognitoUser.storage.rememberMe) {
        // this.authenticationService.getAuthenticatedUser().getSession((err, session) => {
        // //  this.router.navigate(['/home']);
        // });
      }
    } else {
      this.router.navigate(['/sign-in']);
    }
  }

  isLogged() {
    return this.sessionStateService.getHouse() !== undefined;
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts